import axios from "axios";
import { HE } from "@/lib/i18n";

const BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const client = axios.create({ baseURL: BASE, withCredentials: true });

export const pdfUrl = (leadId) => `${BASE}/report/${leadId}/pdf`;

export function formatApiError(detail) {
  if (detail == null) return HE ? "משהו השתבש. נסו שוב." : "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const api = {
  analyze: (domain, source_campaign = "organic") =>
    client.post("/analyze", { domain, source_campaign }).then((r) => r.data),

  createLead: (payload) => client.post("/lead", payload).then((r) => r.data),

  getReport: (leadId) => client.get(`/report/${leadId}`).then((r) => r.data),

  track: (event, extra = {}) =>
    client.post("/track", { event, ...extra }).then((r) => r.data).catch(() => null),

  // admin (session cookie based — httpOnly, set by the backend)
  login: (email, password) =>
    client.post("/auth/login", { email, password }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  stats: () => client.get("/admin/stats").then((r) => r.data),
  leads: (params = {}) => client.get("/admin/leads", { params }).then((r) => r.data),
  leadDetail: (id) => client.get(`/admin/leads/${id}`).then((r) => r.data),
  updateStatus: (id, status) =>
    client.patch(`/admin/leads/${id}/status`, { status }).then((r) => r.data),
  messages: () => client.get("/admin/messages").then((r) => r.data),
  exportUrl: `${BASE}/admin/leads-export`,
};

export default api;
